import { useCurrentWorkspace } from "src/api/queries";
import { useIsFeatureFlagEnabled } from "src/hooks/useIsFeatureFlagEnabled";
import { FEATURE_FLAGS } from "src/router/featureFlags";

type StandalonePerformanceAccess = {
  isEnabled: boolean;
  isLoading: boolean;
};

// Callers must hold off while `isLoading`: the config defaults to enabled, so an
// unloaded workspace would flash the standalone Performance page before the redirect.
export const useStandalonePerformanceAccess =
  (): StandalonePerformanceAccess => {
    const { data: workspace, isLoading } = useCurrentWorkspace();
    const isHiddenByFlag = useIsFeatureFlagEnabled(
      FEATURE_FLAGS.hideStandalonePerformance,
    );
    return {
      isEnabled:
        !isHiddenByFlag &&
        (workspace?.config?.enable_standalone_performance ?? true),
      isLoading,
    };
  };
